import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import {
  Modal,
  Table,
  ConfigProvider,
    Button,
    Space
} from "antd";
import "./index.css";
import "dayjs/locale/zh-cn";
import {HomeStore,CommonStore} from "../../store";
import dictionary from "../../utils/dictionary";

function FindDetails() {
  const { Column } = Table;

  return (
    <Fragment>
      <Modal
        width={"70%"}
        centered
        title={"查看详情"}
        open={HomeStore.recordModal.isOpen}
        destroyOnClose={true}
        onCancel={() => HomeStore.recordModal.close()}
        footer={null}
        loading={HomeStore.tableLoadModal}
      >
        <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
          <Table
            dataSource={HomeStore.recordDataModal.content}
            rowKey={(record: any) => record.id}
            loading={HomeStore.tableLoadModal}
            scroll={{ x: 1000}}
            size="small"
            className="tableSty"
            pagination={{
              current: HomeStore.recordPageData.page + 1,
              pageSize: HomeStore.recordPageData.size,
              onChange: HomeStore.recordPageData.changePage,
              pageSizeOptions: [10, 20, 50, 100],
              showSizeChanger: true,
              total: HomeStore.recordDataModal.totalElements,
              showTotal: () =>
                `共计${HomeStore.recordDataModal.totalElements}条`,
              position: ["bottomLeft"],
            }}
          >
            <Column width={120} ellipsis={true} title="ID" dataIndex="id" />
            <Column width={120} ellipsis={true} title="企业名称" dataIndex="businessCustomerName" />
            <Column width={120} ellipsis={true} title="账户名称" dataIndex="businessCustomerAccountName" />
            <Column width={120} ellipsis={true} title="审核状态" dataIndex="auditStatus" render={(status) => dictionary.recordStatus[status]}/>
            <Column width={120} ellipsis={true} title="操作人" dataIndex="operator" />
            <Column width={200} ellipsis={true} title="经办人姓名" dataIndex="agentName" />
            <Column width={200} ellipsis={true} title="经办人手机号码" dataIndex="agentPhoneNumber" />
              <Column
                  width={100}
                  fixed={"right"}
                  align={'right'}
                  render={(text: string, record: any) => (
                      <Space>
                          <Button size={"small"} onClick={() => HomeStore.approvalModal.open('account',record)}>
                              审批详情
                          </Button>
                      </Space>
                  )}
              />
          </Table>
        </ConfigProvider>
      </Modal>
    </Fragment>
  );
}

export default observer(FindDetails);
